import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  class: "pa-4",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "py-6 text-center" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_my_card, { class: "card" }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "pa-4",
            style: {"text-align":"center"}
          }, " 扫描下方二维码查看当前健康信息 ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: $setup.url,
              style: {"width":"70vw","height":"70vw"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.getQrCode && $setup.getQrCode(...args)))
            }, null, 8, _hoisted_4)
          ])
        ]),
        _: 1,
        __: [1]
      })
    ])
  ]))
}